import * as R from "ramda";
import React, { Component } from "react";
import FlexView from "react-flexview";
import ModalContainer from "../../../modules/commons/ModalContainer";
import SimpleButton from "../../../modules/commons/SimpleButton";
import SimpleModal from "../../../modules/popup/SimpleModal";
import SimpleDDL from "../../../modules/SimpleDDL";
import SimpleInput from "../../../modules/SimpleInput";
import Api from "../../../Services/Api";
import { mapToObjectDDL } from "../../common/mapper";

class MasterSamsatFilter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cabangOptions: [],
    };
  }

  async componentDidMount() {
    const response = await Api.create("NAGAMAS_MASTER_DATA").findAllMasterCabang();
    if (response.ok && !R.isEmpty(response.data.data)) {
      this.setState((prevValue) => ({
        ...prevValue,
        cabangOptions: response.data.data.map((c) => mapToObjectDDL(c.namaDealer, c.kodeCabang)),
      }));
    }
  }

  getDataValue = (fieldName, fallbackValue = "") => {
    return !R.isNil(this.props.state.filterData) && this.props.state.filterData[fieldName]
      ? this.props.state.filterData[fieldName]
      : fallbackValue;
  };

  handleValueChange = (name, value) => {
    this.props.onSetState((prevValue) => ({
      ...prevValue,
      filterData: {
        ...prevValue.filterData,
        [name]: value,
      },
    }));
  };

  handleReset = () => {
    this.props.onSetState((prevValue) => ({
      ...prevValue,
      filterData: {},
    }));
  };

  render() {
    return (
      <SimpleModal
        title="Filter Search"
        visible={this.props.state.filterVisible}
        onClickClose={this.props.onClickClose}
        content={
          <ModalContainer>
              <SimpleInput
                id="input_text_id"
                name="samsatId"
                label="ID"
                value={this.getDataValue("samsatId")}
                onChange={({ target }) => this.handleValueChange(target.name, target.value)}
              />
              <SimpleInput
                id="input_text_nama_samsat"
                name="samsatName"
                label="Nama Samsat"
                value={this.getDataValue("samsatName")}
                onChange={({ target }) => this.handleValueChange(target.name, target.value)}
              />
              <SimpleDDL
                id="select_options_oleh_cabang"
                name="listCabang"
                label="Diakses Oleh Cabang"
                box="multiselect"
                options={this.state.cabangOptions}
                value={this.getDataValue("listCabang", [])}
                onChange={(value, { name }) => this.handleValueChange(name, value)}
              />
              <FlexView hAlignContent="center">
                <SimpleButton type="button" secondary onClick={this.handleReset}>
                  Hapus
                </SimpleButton>
                <SimpleButton onClick={this.props.onSubmit}>Terapkan</SimpleButton>
              </FlexView>
          </ModalContainer>
        }
      />
    );
  }
}

export default MasterSamsatFilter;
